import React, { useEffect, useState, useRef } from 'react';
import parse from 'html-react-parser';
import { getCmsByLanguageAndCode } from './services';
import styles from './CmsContainer.module.scss';
import { usePluginStore } from 'react-pluggable';
import { CAREER } from '../../shared/constants/cms-codes.constants';
import CareerUploadResumeForm from '../../components/fixcenter-career/fixcenter-career';
import { formContainerHtmlId } from '../../components/fixcenter-career/fixcenter-career.service';
import CmsContainerSkeleton from './CmsContainerSkeleton';

function getCms(code: string, languageCode: string): Promise<any> {
    return getCmsByLanguageAndCode(code, languageCode);
}

export default function CmsContainer(props: any) {
    const [cmsObject, setCmsObject] = useState<string>();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const pluginStore: any = usePluginStore();
    let Renderer = pluginStore.executeFunction('Renderer.getRendererComponent');
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const savedLanguageCode = localStorage.getItem('lang');

        if (!savedLanguageCode) {
            setIsLoading(false);
            return;
        }

        let isCancelled = false;
        setIsLoading(true);
        getCms(props.code, savedLanguageCode)
            .then((response: any) => {
                if (!isCancelled) {
                    setCmsObject(response.data);
                }
            })
            .catch(() => {})
            .finally(() => {
                if (!isCancelled) {
                    setIsLoading(false);
                }
            });

        return () => {
            isCancelled = true;
        };
    }, [props.code]);

    useEffect(() => {
        if (props.forwardedRef && containerRef.current) {
            if (typeof props.forwardedRef === 'function') {
                props.forwardedRef(containerRef.current);
            }
        }
    }, [props.forwardedRef]);

    return (
        <div className={styles.main_container}>
            {isLoading ? <CmsContainerSkeleton /> : parse(cmsObject ? cmsObject : '')}
            {!isLoading && props.code === CAREER && (
                <div id={formContainerHtmlId}>
                    <CareerUploadResumeForm />
                </div>
            )}
        </div>
    );
}
